import '../css/style.css';
import 'remixicon/fonts/remixicon.css';

import Swiper from 'swiper';
import { Controller, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/controller';

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

window.Alpine = Alpine;
Alpine.plugin(collapse);

Alpine.data('testimonials', () => ({
  swiper: null,

  init() {
    const swiper = this.$el.querySelector('.swiper');
    const prevBtn = this.$el.querySelector('[data-nav-button="prev"]');
    const nextBtn = this.$el.querySelector('[data-nav-button="next"]');
    const paginationBullets = this.$el.querySelector('.pagination-bullets');
    const paginationFraction = this.$el.querySelector('.pagination-fraction');

    this.swiper = new Swiper(swiper, {
      modules: [Navigation, Pagination],
      loop: true,
      slidesPerView: 1,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      pagination: {
        el: paginationBullets,
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        640: {
          loop: true,
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 24,
        },
        1024: {
          loop: true,
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
      },
      on: {
        slideChange(swiper) {
          const slidesPerGroup = swiper.params.slidesPerGroup ?? 1;
          const totalPages = Math.ceil(swiper.slides.length / slidesPerGroup);
          const currentPage = Math.floor(swiper.realIndex / slidesPerGroup) + 1;

          paginationFraction.innerHTML = `${currentPage} / ${totalPages}`;
        },
      },
    });
  },

  destroy() {
    this.swiper?.destroy(true, true);
  },
}));

Alpine.data('compareSlider', () => ({
  swiperImg: null,
  swiperInfo: null,

  init() {
    const swiperImg = this.$el.querySelector('.swiper-img');
    const swiperInfo = this.$el.querySelector('.swiper-info');
    const prevBtn = this.$el.querySelector('[data-nav-button="prev"]');
    const nextBtn = this.$el.querySelector('[data-nav-button="next"]');
    const paginationBullets = this.$el.querySelector('.pagination-bullets');
    const paginationFraction = this.$el.querySelector('.pagination-fraction');

    this.swiperInfo = new Swiper(swiperInfo, {
      modules: [Navigation, Pagination],
      loop: true,
      slidesPerView: 1,
      allowTouchMove: false,
    });

    this.swiperImg = new Swiper(swiperImg, {
      modules: [Controller, Navigation, Pagination],
      loop: true,
      slidesPerView: 1,
      allowTouchMove: false,
      longSwipes: false,
      shortSwipes: false,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      pagination: {
        el: paginationBullets,
        type: 'bullets',
        clickable: true,
      },
      controller: {
        control: this.swiperInfo,
      },
      on: {
        slideChange(swiper) {
          const totalSlides = swiper.slides.length;
          const currentSlide = swiper.realIndex + 1;

          paginationFraction.innerHTML = `${currentSlide} / ${totalSlides}`;
        },
      },
    });
  },

  destroy() {
    this.swiperImg?.destroy(true, true);
    this.swiperInfo?.destroy(true, true);
  },
}));

Alpine.data('compareItem', () => ({
  handlePos: 50,
  dragging: false,

  startDrag(event) {
    this.dragging = true;
    this.updateHandlePos(event);
  },

  drag(event) {
    if (!this.dragging) return;
    this.updateHandlePos(event);
  },

  updateHandlePos(event) {
    const rect = this.$el.getBoundingClientRect();
    const clientX = event.touches?.[0]?.clientX ?? event.changedTouches?.[0]?.clientX ?? event.clientX;
    const offsetX = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    this.handlePos = (offsetX / rect.width) * 100;
  },
}));

Alpine.data('vehicleList', () => ({
  activeTab: 'P',

  getItems(ref) {
    return this.$refs[ref] ? [...this.$refs[ref].querySelectorAll('div[x-data]')] : [];
  },

  openAll() {
    this.getItems(`items-${this.activeTab}`).forEach(item => Alpine.$data(item).open = true);
  },

  closeAll() {
    this.getItems(`items-${this.activeTab}`).forEach(item => Alpine.$data(item).open = false);
  },

  resetOpen() {
    Object.keys(this.$refs)
      .filter(key => key.startsWith('items-'))
      .flatMap(key => this.getItems(key))
      .forEach(item => Alpine.$data(item).open = false);
  },
}));

Alpine.start();
